import { useTranslation } from 'react-i18next'
import { Location } from 'react-router'
import dayjs from 'dayjs'

import { SessionStorage } from 'lib/storage'
import { useGetTodayUserBirthdayQuery } from 'store/api/yay/activity'
import { Link, useNavigate } from 'features/i18n/router'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { MODAL_MODE } from '../config'

import { UserList } from 'components'
import Button from 'components/Button'

import './style.scss'

type Props = {
  location: Location
  birthdate: number
}

const ActivityUsersBirthdayModal = ({ location, birthdate }: Props) => {
  const { t } = useTranslation()
  const { generatePageModalUrl } = usePageModal()
  const navigate = useNavigate()

  const { data } = useGetTodayUserBirthdayQuery({ birthdate })

  const isToday = dayjs(birthdate * 1000).isToday()

  return (
    <div className="Modal__wrapper ActivityUsersBirthdayModal">
      <div className="Modal__header">
        <Link
          className="Modal__header__close Modal__header__close--back"
          to={location.pathname}
        />

        <h2 className="Modal__header__h2">
          {isToday
            ? t('activity_users_birthday.today')
            : t('activity_users_birthday.not_today', {
                birthdate: dayjs(birthdate * 1000).format('MM/DD'),
              })}
        </h2>
      </div>

      <div className="Modal__body">
        <UserList
          users={data ?? []}
          customDescription={(user) => {
            const letterAlreadySent = SessionStorage.birthdayLetter.get({})[
              user.id
            ]

            if (letterAlreadySent)
              return <p>{t('activity_users_birthday.letter_already_sent')}</p>

            return null
          }}
          actionButton={(user) => {
            return (
              <Button
                icon="chat"
                onClick={async () => {
                  navigate(
                    generatePageModalUrl(MODAL_MODE.CREATE_USER_REVIEW, {
                      userId: user.id,
                      birthday: true,
                      returnPath: location.pathname + location.search,
                    })
                  )
                }}
              >
                {t('common.write_letter')}
              </Button>
            )
          }}
          showOnlineStatus
          fullWidth
        />
      </div>
    </div>
  )
}

export default ActivityUsersBirthdayModal
